import { render } from "./highlightsBlock.vue?vue&type=template&id=4fad6d60&scoped=true&ts=true"
import script from "./highlightsBlock.vue?vue&type=script&lang=ts"
export * from "./highlightsBlock.vue?vue&type=script&lang=ts"

import "./highlightsBlock.vue?vue&type=style&index=0&id=4fad6d60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fad6d60"]])

export default __exports__